// extracted by mini-css-extract-plugin
module.exports = {"content":"ab0f2__index-module__content"};